import { Input } from '@iwoca/orion';
import { FieldError, UseFormRegister } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';
import { TFormValues } from '../CheckoutLinkDebitCardForm';

export const CardholderNameField = ({
    formRegister,
    error
}: {
    formRegister: UseFormRegister<TFormValues>;
    error?: FieldError;
}) => {
    const intl = useIntl();

    const errorMessage = intl.formatMessage({
        id: '_.link_debit_card.cardholder_name_required',
        defaultMessage: 'Cardholder name is required'
    });

    return (
        <DebitCardFieldWrapper
            label={intl.formatMessage({
                id: '_.link_debit_card.cardholder_name',
                defaultMessage: 'Cardholder name'
            })}
            htmlFor="cardholderName"
            error={error ? errorMessage : null}
        >
            <Input
                type="text"
                id="cardholderName"
                placeholder="John Smith"
                className="fs-exclude"
                {...formRegister('cardholderName', { required: true })}
            />
        </DebitCardFieldWrapper>
    );
};
